import Phaser from 'phaser'
import { assetsImageLoader, assetsSoundsLoader } from '../utils/funtions'
import { DRAG_ELEMENT_CONFIG } from '../constants/game'
import WordComponent from './word'
import Cursor from './cursor';
const FOR_CONFIG = true;
export default class DragElementComponent {
  /** @type { Phaser.GameObjects.Image } */
  dragElement
  /**
   * @type {{
   *  context: Phaser.Scene,
   *  word: string,
   *  onDropSrc: string,
   *  onDragSrc: string,
   *  posX: number,
   *  posY: number,
   *  index: number,
   *  prefixElement: string,
   * }}
   **/
  config = {}


  /** @type { Cursor } */
  cursor
  /**
   *
   * @param {Phaser.Scene} context
   * @param {Cursor} cursor
   * @param {WordData} word
   */
  constructor(context, cursor, word, index) {
    this.config = {
      context,
      raw: word,
      word: word.word,
      wordSrc: word.stickSrc,
      posX: word.stickPosX,
      posY: word.stickPosY,
      index,
    }
    this.cursor = cursor;
    this.sfx = {};
  }

  // LOAD assets
  preload() {
    this.config.prefixElement = `${this.config.context.scene.key}-${this.config.word}-${this.config.index}-`
    const assetsToLoad = {
      'wordSrc': this.config.wordSrc,
    }

    assetsImageLoader(
      assetsToLoad,
      this.config.prefixElement,
      this.config.context
    )

    assetsSoundsLoader(DRAG_ELEMENT_CONFIG.sfx,
      "word-", this.config.context);
    // this.config.context.load.audio('drop-wrong', DRAG_ELEMENT_CONFIG.sfx["drop-wrong"]);
    // this.config.context.load.audio('drop-correct', DRAG_ELEMENT_CONFIG.sfx["drop-correct"]);
    // this.config.context.load.audio('pickup', DRAG_ELEMENT_CONFIG.sfx["pickup"]);
  }

  create() {
    const context = this.config.context;
    this.sfx.drop_wrong = context.sound.add('word-drop-wrong');
    this.sfx.drop_correct = context.sound.add('word-drop-correct');
    this.sfx.pickup = context.sound.add('word-pickup');

    this.makeWord();
  }



  makeWord() {
    const cursor = this.cursor;
    const stickerWord = this.config.context.add
      .image(
        0,
        0,
        `${this.config.prefixElement}wordSrc`
      )
      .setOrigin(0)
      .setDataEnabled()
      .setData({
        word: this.config.word,
        dropped: false
      });

    try {
      stickerWord.blendMode = Phaser.BlendModes[(this.config.raw.blendType || "MULTIPLY").toUpperCase()];
    } catch (e) {
      // NO BLEND FOUND
      console.warn(this.config.word, "BLEND MODE:", e);
    }

    try {
      if (this.config.raw.raw.size) {
        stickerWord.setDisplaySize(this.config.raw.raw.size.width, this.config.raw.raw.size.height)
      }
    } catch (e) {
      // NO BLEND FOUND
      console.warn(this.config.word, "BLEND MODE:", e);
    }


    const word = new WordComponent(this.config.context, this.config.word)

    var container = this.config.context.add.container(this.config.posX, this.config.posY, [stickerWord, word.container]);

    container.setSize(stickerWord.width, stickerWord.height)
    container.setDepth(DRAG_ELEMENT_CONFIG.dropDepth);

    container.getAt(0).setVisible(true);
    container.getAt(1).setVisible(false);
    /////// DRAG EVENTS

    stickerWord.setInteractive()
      .on(
        'dragstart',
        function (_, dragX, dragY) {
          // pointer, dragX, dragY 
          container.getAt(0).setVisible(false);
          container.getAt(1).setVisible(true);
          container.setDepth(DRAG_ELEMENT_CONFIG.dragDepth)
          this.sfx.pickup.play();
          cursor.hidden();
        },
        this
      )
      .on(
        'drag',
        function (pointer, dragX, dragY) {
          // pointer, dragX, dragY
          /** @type Phaser.Input.Pointer  */
          let _pointer = pointer

          container.x = _pointer.worldX - word.container.width / 2
          container.y = _pointer.worldY - word.container.height / 2
        },
        this
      )
      .on(
        'dragend',
        function (_, dragX, dragY) {
          cursor.default();
          const dropped = stickerWord.data.get('dropped');
          if (dropped) {
            this.sfx.drop_correct.play();
            container.destroy();
            return;
          }
        
          this.sfx.drop_wrong.play();
          // pointer, dragX, dragY
          container.getAt(0).setVisible(true);
          container.getAt(1).setVisible(false);
          container.setDepth(DRAG_ELEMENT_CONFIG.dropDepth)


          /** @type Phaser.Tweens.Tween */
          let tweensConfig = {
            targets: container,
            x: this.config.posX, y: this.config.posY,
            duration: 500,
            ease: 'Elastic',
            easeParams: [0.4, 0.5],
          }

          this.config.context.tweens.add(tweensConfig)

        },
        this
      )



    this.config.context.input.setDraggable(stickerWord);

    /// ---- FOR CONFIGURATION  ---
    if (FOR_CONFIG) {
      if (!window.$$words) {
        window.$$words = {};
        window.$$words_getall = () => {
          return Object.values(window.$$words).map((_container) => {
            return {
              stickPosX: Number(Number(_container.x).toFixed(2)),
              stickPosY: Number(Number(_container.y).toFixed(2)),
              word: _container._config.word,
              isLocked: false,
              stickSrc: _container._config.wordSrc
            }
          })
        }
      }
      container._config = this.config;
      let tag = this.config.word.split(" ").join("_");
      let n = 0;
      //  console.log(this.config.word, container)
      while (window.$$words["w_" + tag] != null) {
        n++;
        tag = this.config.word + n;
      }
      window.$$words["w_" + tag] = container
    }


  }
}
